module.exports = __webpack_public_path__ + "img/introduce2.4ffc88c2.png";